import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Loading } from 'rp-react-table';
import axios, { CancelToken, isCancel } from 'axios';
import FetchError from '../FetchError';
import fixMobileSafariWhiteScreenBug from '../../utils/fixMobileSafariWhiteScreenBug';

class TabFetchProvider extends PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            shouldFetch: true,
            errorTimeout: null,
            isMobile: localStorage.getItem('isMobile') === 'true',
        };
    }

    componentDidMount() {
        window.addEventListener('screen-resized', this.resizeUpdate);

        this.fetchData(this.props.params);
    }

    componentWillReceiveProps({ params }) {
        const { id, tab } = this.props.params;
        if (id === params.id && tab === params.tab) {
            return;
        }

        this.cancelRequest();
        this.setState({ shouldFetch: true, data: {} });

        this.fetchData(params);
    }

    componentWillUnmount() {
        window.removeEventListener('screen-resized', this.resizeUpdate);
    }

    resizeUpdate = (event) => {
        const isMobile = event.detail;
        this.setState({
            ...this.state,
            isMobile,
        });
    }

    cancelRequest = () => null

    fetchData({ id, name, tab, type }) {
        const indexTab = this.props.route.fetchPath || '';
        const tabOrIndex = tab || indexTab;

        axios.get(`tab/${type}/${id}/${name}/${tabOrIndex}`, {
            cancelToken: new CancelToken((cancel) => {
                this.cancelRequest = cancel;
            }),
        }).then(({ data }) => {
            this.setState({ shouldFetch: false, data }, () => {
                fixMobileSafariWhiteScreenBug();
            });
        }).catch((error) => {
            if (isCancel(error)) {
                return;
            }

            console.warn(error);
            this.setState({
                errorTimeout: setTimeout(this.refresh, 20000),
            });
        });
    }

    refresh = () => {
        clearTimeout(this.state.errorTimeout);
        this.setState({
            errorTimeout: null,
        });
        this.fetchData(this.props.params);
    }

    render() {
        const {
            shouldFetch, data: fetchedData, errorTimeout, isMobile,
        } = this.state;
        const {
            route: { Tab }, params, data, hasAccess,
        } = this.props;

        return shouldFetch ? (
            <section>
                <Loading />
                {errorTimeout && <FetchError refresh={this.refresh} />}
            </section>
        ) : (
            <Tab
                data={Object.assign({}, data, fetchedData)}
                params={params}
                isMobile={isMobile}
                hasAccess={hasAccess}
            />
        );
    }
}

TabFetchProvider.propTypes = {
    route: PropTypes.shape({
        Tab: PropTypes.func,
        fetchPath: PropTypes.string,
    }).isRequired,
    params: PropTypes.shape({
        type: PropTypes.string,
        id: PropTypes.string,
        name: PropTypes.string,
        tab: PropTypes.string,
    }).isRequired,
    data: PropTypes.shape({
        bigRaceWins: PropTypes.arrayOf(PropTypes.shape({
            raceDate: PropTypes.string,
            raceInstanceTitle: PropTypes.string,
            horseStyleName: PropTypes.string,
            jockeyStyleName: PropTypes.string,
            prizeSterling: PropTypes.number,
            trainerStyleName: PropTypes.string,
        })),
    }),
    hasAccess: PropTypes.bool,
};

export default TabFetchProvider;




// WEBPACK FOOTER //
// ./src/js/shared/providers/TabFetchProvider.jsx